import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

export const loginStaff = async (
  staffCode,
  password
) => {
  const { data } =
    await axios.post(
      `${API}/staff-auth/login`,
      {
        staffCode,
        password,
      },
      {
        withCredentials: true,
      }
    );

  return data;
};

export const getCurrentStaff =
  async () => {
    const { data } =
      await axios.get(
        `${API}/staff-auth/me`,
        {
          withCredentials: true,
        }
      );

    return data;
  };

export const logoutStaff =
  async () => {
    const { data } =
      await axios.post(
        `${API}/staff-auth/logout`,
        {},
        {
          withCredentials: true,
        }
      );

    return data;
  };